import React from 'react';

const PageNotFound = () =>
    <div className="PageNotFound">
        <h1>404</h1>
        <p>Page Not Found :(</p>
    </div>

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/pages/PageNotFound.jsx